import Vue from 'vue';
import Router from 'vue-router';
import BaseSidebar from './components/sections/BaseSidebar/BaseSidebar.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      component: () => import('./components/sections/AppLayout/AppLayout.vue'),
      children: [
        {
          name: 'dashboard',
          path: '/dashboard',
          meta: {
            shortName: 'Dashboard',
          },
          props: { sidebar: false, content: true },
          components: {
            content: () => import(/* webpackChunkName: "dashboard" */ './components/pages/Dashboard/Dashboard.vue'),
            sidebar: BaseSidebar,
          },
        },
        {
          path: '/portfolio',
          name: 'portfolio',
          props: { sidebar: false, content: true },
          components: {
            content: () => import(/* webpackChunkName: "portfolio" */ './components/pages/Portfolio/Portfolio.vue'),
            sidebar: BaseSidebar,
          },
        },
        {
          path: '/jobs',
          name: 'jobs',
          props: { sidebar: false, content: true },
          components: {
            content: () => import(/* webpackChunkName: "jobs" */ './components/pages/Jobs/Jobs.vue'),
            sidebar: BaseSidebar,
          },
        },
        {
          path: '/news',
          name: 'news',
          props: { sidebar: false, content: true },
          components: {
            content: () => import(/* webpackChunkName: "news" */ './components/pages/News/News.vue'),
            sidebar: BaseSidebar,
          },
        },
      ],
    },
  ],
});
